


















import Vue from 'vue'
import Store from '@/services/Store'
import MainArea from '@/components/MainArea.vue'
import ImageArea from '@/components/ImageArea.vue'
import TextArea from '@/components/TextArea.vue'

export default Vue.extend({
  name: "QuizResults",
  methods: {
    scoreInPercent(){ return Store.quizState.getScoreInPercent() },
    resultTitle(){
      if(this.scoreInPercent() == 100){
        return "🎉"
      }else if(this.scoreInPercent() > 70){
        return "👍"
      }else if(this.scoreInPercent() > 30){
        return "🤔"
      }else{
        return "😱"
      }
    },
    quizResultsSummary(){
      if(this.scoreInPercent() == 100){
        return Store.quizState.getReportBestText()
      }else if(this.scoreInPercent() > 70){
        return Store.quizState.getReportGoodText()
      }else if(this.scoreInPercent() > 30){
        return Store.quizState.getReportBadText()
      }else{
        return Store.quizState.getReportWorstText()
      }
    },
    quizResultsImage(){
      if(this.scoreInPercent() == 100){
        return Store.quizState.getReportBestImage()
      }else if(this.scoreInPercent() > 70){
        return Store.quizState.getReportGoodImage()
      }else if(this.scoreInPercent() > 30){
        return Store.quizState.getReportBadImage()
      }else{
        return Store.quizState.getReportWorstImage()
      }
    },
    handleNextClick(){
      // Pick different quiz
      Store.initRandomPastQuiz().then((newQuiz: any) => {
        // Reset Quiz progress
        this.$root.$data.user = {
          progress: 0,
          score: 0,
          wrongAnswerCount: 0,
          selectedAnswer: ""
        }

        this.$router.push('/')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    if (to.params.score == undefined) next({ name: 'QuizIntro' })
    else next()
  },
  components: {
    MainArea, ImageArea, TextArea
  }
})
